import { NextImage, PublicAccount } from '@apeiron/temp'
import { Box, Button, styled, Typography } from '@mui/material'
import IconOwner from '@public/icons/icon-owner.png'
import { ZERO_ADDRESS } from '@src/constants/activity'
import { DEFAULT_ANIMATE_DURATION } from '@src/constants/layout'
import Link from 'next/link'
import queryString from 'query-string'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const OwnerContainer = styled(Button)`
  display: flex;
  gap: 6px;
  padding: 0px;
  width: 100%;
  :hover {
    .Custom-Name {
      color: #ffbf36;
    }
  }
`

const Avatar = styled(NextImage)`
  aspect-ratio: 1;
  width: 53px;
`

const OwnerTextContainer = styled(Box)`
  align-items: flex-end;
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  column-gap: 10px;
  row-gap: 4px;
  overflow: hidden;
  text-transform: none;
`

const OwnerUpperSection = styled(Box)`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const OwnerTitle = styled(Typography)`
  font-size: 16px;
  font-weight: 300;
  line-height: 16px;
  color: #c4c4c4;
`

const OwnerName = styled(Typography)`
  font-size: 16px;
  font-weight: 300;
  line-height: 16px;
  color: #ffffff;
  transition: ${DEFAULT_ANIMATE_DURATION}ms color;
`

const OwnerId = styled(Typography)`
  font-size: 12px;
  font-weight: 300;
  line-height: 14px;
  color: #c4c4c4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const ApeironOwnerView: FC<Props> = (props: Props) => {
  const { className, owner, route } = props

  const { t } = useTranslation()

  const url = queryString.stringifyUrl({
    url: route,
    query: { ownerWalletAddresses: owner.walletAddress }
  })

  const ownerName =
    owner.walletAddress === ZERO_ADDRESS ? t('owner.empty_address') : owner.name

  return (
    <Link href={url} className={className}>
      <OwnerContainer>
        <Avatar src={IconOwner} />
        <OwnerTextContainer>
          <OwnerUpperSection>
            <OwnerTitle>{t('owner.title')}</OwnerTitle>
            {owner.name !== '' && (
              <OwnerName className='Custom-Name'>{ownerName}</OwnerName>
            )}
          </OwnerUpperSection>
          <OwnerId>{`(${owner.walletAddress})`}</OwnerId>
        </OwnerTextContainer>
      </OwnerContainer>
    </Link>
  )
}

type Props = {
  className?: string
  owner: PublicAccount
  route: string
}

export default ApeironOwnerView
